import React from 'react';
import { MappingRow } from './MappingRow';
import { processData } from '../../../common/utils/rest_utils';

export const MappingForm = ({
  mapping,
  setMapping,
  projectDetail,
  collections,
  collectionName,
}) => {
  const collection = collections.find((coll) => coll.collectionName === collectionName);

  const createNewParamRow = (rowObj) => {
    const newMapping = processData(mapping, rowObj);
    setMapping(newMapping);
  };

  return (
    <div className="row pt-2">
      <div className="col-md-4 col-lg-4">Key</div>
      <div className="col-md-8 col-lg-8">Value</div>
      {mapping.map((row) => (
        <MappingRow
          key={row.id}
          row={row}
          createNewParamRow={createNewParamRow}
          projectDetail={projectDetail}
          collection={collection}
          collections={collections}
        />
      ))}
    </div>
  );
};
